import { Box, Button, Center, Flex, Grid, GridItem, Heading, Skeleton, Text } from '@chakra-ui/react';
import { useEffect } from 'react';
import { isEmptyObject } from '../../../helper/utils/isEmptyObject';
import useOnlineSales from '../hooks/useOnlineSales';

export default function ProductTimeSlot({ isLoading = false, isDisabled = false, timeslots = [], product = {}, onSelectTime = (time) => {} }) {
    let disabled = isDisabled;
    const { selectedDetailTimeslot, detail } = useOnlineSales();
    const { detail: productDetail } = detail || {};

    const getDisabledTimeslot = (timeslot = {}) => {
        const date = new Date(product['date'] || new Date().toISOString());
        const today = new Date();

        if (date.toDateString() === today.toDateString()) {
            const sessionName = timeslot['StartTime'] || '00:00:00';
            const [sessionHour, sessionMinute] = sessionName.split(':').map(Number);

            const currentTotalMinutes = today.getHours() * 60 + today.getMinutes();
            const sessionTotalMinutes = sessionHour * 60 + sessionMinute;

            return sessionTotalMinutes <= currentTotalMinutes;
        }

        return false;
    };

    const disabledTimeslotByDate = (timeslot = {}) => {
        if (getDisabledTimeslot(timeslot)) {
            return true;
        }

        const menuCode = (productDetail['menuCode'] || '').trim();
        const timeSloteCode = (timeslot['ModifItemCode'] || '').trim();
        const currentDate = product['date'] || '';

        const datas = [
            // {
            //     // 10.00 - 11.00
            //     date: new Date('2026-03-20'),
            //     timeslots: [],
            //     products: ['TSI0205002', 'TSI0205001', 'SPI0204008', 'SPI0204007', 'SPI0204006', 'SPI0204005', 'SPI0204004', 'SPI0204003', 'SPI0204002', 'SPI0204001', 'PPI0205004', 'PPI0205003', 'PPI0205002', 'PPI0205001', 'PPI0101008', 'PPI0101007', 'PPI0101006', 'PPI0101005', 'SPI0101022', 'SPI0101021', 'SPI0101020', 'SPI0101019', 'SPI0101018', 'SPI0101017', 'SPI0101016', 'SPI0101015'],
            // },
        ];

        return datas.some((data) => {
            if (!currentDate) return false;

            const isDateMatch = new Date(currentDate).toDateString() === data.date.toDateString();
            const isTimeslotMatch = data.timeslots.includes(timeSloteCode);
            const isProductMatch = data.products.includes(menuCode);

            return isDateMatch && isTimeslotMatch && isProductMatch;
        });
    };

    useEffect(() => {
        if (!isEmptyObject(detail) && (timeslots || []).length > 0) {
            const timeslot = timeslots[0] || {};

            if (!isEmptyObject(timeslot)) {
                onSelectTime(timeslot);
            }
        }
    }, [timeslots, detail]);

    if (disabled) {
        return null;
    }

    return (
        <Box w='full'>
            <Box w='full' mb={5}>
                <Flex gap={2} alignItems='center'>
                    <Heading fontSize={{ base: 'xl', md: 'xl' }} fontWeight={500}>
                        {disabled ? 'Current Timeslot' : 'Select Timeslot'}
                    </Heading>
                    <Text fontSize='sm' color='red.400' fontWeight={700} fontStyle='italic'>
                        *Required
                    </Text>
                </Flex>

                {disabled && (
                    <Text color='red' fontSize='14px' fontStyle='italic' mt={2}>
                        *You can only select a booking time slot once.
                    </Text>
                )}
            </Box>
            <Box w='full'>
                <Grid
                    w='full'
                    alignItems='center'
                    justifyContent='start'
                    gridTemplateColumns={{
                        base: 'repeat(2, 1fr)',
                        md: 'repeat(5, 1fr)',
                    }}
                    gap={3}>
                    {timeslots.length === 0 && (
                        <GridItem colSpan={{ base: 2, md: 5 }} border='1px solid #E2E8F0' rounded='xl' p={5}>
                            <Center w='full' h='full' flexDirection='column' gap={1}>
                                <Text fontSize='16px' fontWeight={600} color='gray'>
                                    No timeslots available
                                </Text>
                            </Center>
                        </GridItem>
                    )}
                    {timeslots.length > 0 &&
                        timeslots.map((time, index) => {
                            const productTimeSlot = (selectedDetailTimeslot || {})['ModifItemCode'] || '';
                            const isSelected = (time['ModifItemCode'] || '') == productTimeSlot;
                            const outOfCapacity = (time['capacity'] ?? 0) <= 0;

                            // Party timeslot is not available
                            const isAvailableTimeslotParty = (productDetail?.menuType ?? '') === 'party' && (time?.isAvailable ?? '') === 'N';
                            // const disabledTimeslot = (disabled && !isSelected) || outOfCapacity || getDisabledTimeslot(time) || disabledTimeslotByDate(time) || isAvailableTimeslotParty;

                            // if (disabledTimeslot && !isSelected) {
                            //     return null;
                            // }

                            return (
                                <GridItem key={time['ModifItemCode'] || index}>
                                    <Skeleton isLoaded={!isLoading} rounded='xl' h='full' w='full'>
                                        <Button
                                            w='full'
                                            // isDisabled={disabledTimeslot}
                                            // opacity={disabledTimeslot ? 0.35 : 1}
                                            // variant={disabledTimeslot ? 'outline' : isSelected ? 'solid' : 'outline'}
                                            // colorScheme={disabledTimeslot ? 'gray' : isSelected ? 'primary' : 'gray'}
                                            px={8}
                                            h='65px'
                                            // cursor={disabledTimeslot ? 'not-allowed' : 'pointer'}
                                            // transition='all 0.25s ease-in-out'
                                            // _hover={disabledTimeslot ? {} : { bg: 'primary.100' }}
                                            // onClick={
                                            //     disabledTimeslot
                                            //         ? null
                                            //         : () => {
                                            //               onSelectTime(time);
                                            //           }
                                            // }
                                            variant={isSelected ? 'solid' : 'outline'}
                                            colorScheme={isSelected ? 'primary' : 'gray'}
                                            cursor='pointer'
                                            onClick={() => onSelectTime(time)}>
                                            <Center w='full' h='full' flexDirection='column' gap={1}>
                                                <Flex flexDir='column'>
                                                    <Text
                                                        fontSize='16px'
                                                        fontWeight={600}
                                                        color={isSelected ? 'white' : 'primary.600'}
                                                        // color={disabledTimeslot ? 'gray' : isSelected ? 'white' : 'primary.600'}
                                                    >
                                                        {time['sessionName']}
                                                    </Text>
                                                    {/* {disabledTimeslot && (
                                                        <Text fontSize='12px' color='red.400' mt={1}>
                                                            Unavailable
                                                        </Text>
                                                    )} */}
                                                </Flex>
                                            </Center>
                                        </Button>
                                    </Skeleton>
                                </GridItem>
                            );
                        })}
                </Grid>
            </Box>
        </Box>
    );
}
